export default __webpack_public_path__ + "static/media/anurag.6a8ef075.jpg";